import {createSelector} from "reselect";
import {failedMessages} from "utils/selectors";
import {initialState} from "./reducer";
import {selectTimeSlotPageDomain} from "containers/TimeSlotPage/selectors";

/**
 * Direct selector to the newTreatmentPage state domain
 */

const selectNewTreatmentPageDomain = state =>
  state.get("newTreatmentPage", initialState);

/**
 * Other specific selectors
 */

export const makeSelectPatientFailed = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    failedMessages(subState, "patientStepFailed"),
  );

export const makeSelectPatient = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("patient"),
  );

export const makeSelectLoading = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("loading"),
  );

export const makeSelectPatientStepInProgress = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("patientStepInProgress"),
  );

export const makeSelectTreatmentPlan = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("treatmentPlan"),
  );

export const makeSelectTreatmentLoading = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("treatmentLoading"),
  );

export const makeSelectTreatmentsNewTreatment = () =>
  createSelector(selectNewTreatmentPageDomain, subState => {
    const treatments = subState.get("treatments").toJS();
    return treatments.map(treatment => {
      if (!treatment.treatmentId) {
        // eslint-disable-next-line no-param-reassign
        treatment.treatmentId = treatment.id;
      }
      return treatment;
    });
  });

export const makeSelectTimeWindow = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("timeWindow"),
  );

export const makeSelectHasPatient = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("hasPatient"),
  );

export const makeSelectDontSkip = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("dontSkip"),
  );

export const makeSelectPatientIdLoading = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("patientIdLoading"),
  );

export const makeSelectTreatmentToPlan = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("treatmentToPlan"),
  );

export const makeSelectTimeSlot = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("timeSlot"),
  );

export const makeSelectEditingTreatment = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("editingTreatment"),
  );

export const makeSelectIsEditingPlannedTreatment = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("isEditingPlannedTreatment"),
  );

export function userStepLoading(subState) {
  const list = [];
  list.push(subState.get("endProductsLoading"));
  list.push(subState.get("patientIdLoading"));
  list.push(subState.get("treatmentPlanIdLoading"));

  return list.includes(true);
}

export const makeSelectUserStepLoading = () =>
  createSelector(selectNewTreatmentPageDomain, userStepLoading);

export const makeSelectTimeSlotData = () =>
  createSelector(selectNewTreatmentPageDomain, subState => {
    const timeSlotData = subState.get("timeSlotData");
    if (!timeSlotData) {
      return timeSlotData;
    }
    if (!timeSlotData.plannedTreatments) {
      timeSlotData.plannedTreatments = [];
    }
    return timeSlotData;
  });

export const makeSelectTimeSlotDataLoading = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("timeSlotDataLoading"),
  );

export const makeSelectCheckAvailabilityFailedMessage = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("checkAvailabilityFailedMessage"),
  );

export const makeSelectCheckAvailabilityLoading = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("checkAvailabilityLoading"),
  );

export const makeSelectPlannedDay = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("plannedDays"),
  );

export const makeSelectPlannedDayLoading = () =>
  createSelector(selectTimeSlotPageDomain, subState =>
    subState.get("plannedDaysLoading"),
  );

export const makeSelectTreatmentDrivers = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("drivers"),
  );

export const makeSelectTreatmentDurationLoading = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("treatmentDurationLoading"),
  );

export const makeSelectTreatmentDuration = () =>
  createSelector(selectNewTreatmentPageDomain, subState =>
    subState.get("treatmentDuration"),
  );

/**
 * Default selector used by NewTreatmentPage
 */

const makeSelectNewTreatmentPage = () =>
  createSelector(selectNewTreatmentPageDomain, subState => subState.toJS());

export default makeSelectNewTreatmentPage;
export { selectNewTreatmentPageDomain };
